export default __webpack_public_path__ + "static/media/icon-ic-close-bold.9b1e73fb.svg";